module.exports = __webpack_public_path__ + "static/TradeGothicLTPro-Light-e979dcb5b403ccf138216ac037aed40a.woff";